<script setup>
const props = defineProps({
	header: {
		type: Object,
		required: false,
	},
})
</script>

<template>
	<div class="w-full rounded-xl bg-white shadow-lg">
		<!-- Compact Header -->
		<div class="flex gap-2 border-b-[0.5px] border-snk-light-900 px-5 py-4" v-if="header?.type == 'compact'">
			<div class="-pt-[.5rem] text-sm font-semibold uppercase">{{ header.title }}</div>
		</div>
		<!-- Centered Header -->
		<div class="flex flex-col items-center gap-2 border-b-[0.5px] border-snk-light-900 py-14" v-if="header?.type == 'centered'">
			<div class="h6">{{ header.title }}</div>
			<p class="light" v-if="header.description">{{ header.description }}</p>
		</div>

		<slot />
	</div>
</template>
